import {
  SxProps,
  Theme,
  Tooltip,
  TooltipProps,
  Typography,
  TypographyProps,
} from '@mui/material';

interface TypographyWithEllipsisProps extends TypographyProps {
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
  shouldShowTooltip?: boolean;
  tooltipProps?: Omit<TooltipProps, 'children' | 'title'>;
}

export const TypographyWithEllipsis = ({
  sx = {},
  children,
  shouldShowTooltip = true,
  tooltipProps,
  ...typographyProps
}: TypographyWithEllipsisProps) => {
  if (!children) {
    return null;
  }

  return (
    <Tooltip
      title={shouldShowTooltip ? children : ''}
      disableInteractive
      {...tooltipProps}
    >
      <Typography
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          ...sx,
        }}
        {...typographyProps}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};
